const NAV_ID = 'mobile-nav';
const MENU_ITEM = 'menu-item';
const MENU_ACTIVE_CLASS = 'menu--active';
const CURR_MENU_ACTIVE_CLASS = 'current-menu-item';
const PARENT_MENU_CLASS = 'menu-item-has-children';
const CURR_PARENT_MENU_CLASS = 'current-menu-parent';
const SUBMENU_ACTIVE_CLASS = 'submenu--active';

class MobileNav {
    constructor() {
        this._nav = document.getElementById(NAV_ID);

        this._nav && this._run();
    }
    _run = () => {
        this._menuItems = this._nav.querySelectorAll(`.${MENU_ITEM}`);
        this._nav.addEventListener('click', this._toggleMenu);
        //this._checkActiveMenus();
    };

    _delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    _resetSubMenus = async (element) => {
        for (const menuItem of this._menuItems) {
            if (menuItem !== element) {
                if (menuItem.classList.contains(MENU_ACTIVE_CLASS)) {
                    menuItem.classList.remove(MENU_ACTIVE_CLASS);
                    document.body.classList.remove(MENU_ACTIVE_CLASS);
                    await this._delay(300);
                }
            }
        }
    };

    _toggleMenu = async (e) => {
        const menuItem = e.target.closest(`.${MENU_ITEM}`);
        if (menuItem) {
            await this._resetSubMenus(menuItem);
            menuItem.classList.toggle(MENU_ACTIVE_CLASS);
            this._updateBodyClass();
        }
        let activeMenuExists = false;
        for (const menuItem of this._menuItems) {
            if (menuItem.classList.contains(MENU_ACTIVE_CLASS)) {
                activeMenuExists = true;
            }
        }
        if (!activeMenuExists) {
            //this._checkActiveMenus();
        }
    };

    _checkActiveMenus = () => {
        this._menuItems.forEach((menuItem) => {
            if (menuItem.classList.contains(CURR_MENU_ACTIVE_CLASS)) {
                menuItem.classList.add(MENU_ACTIVE_CLASS);
            } else if (menuItem.classList.contains(CURR_PARENT_MENU_CLASS)) {
                menuItem.classList.add(MENU_ACTIVE_CLASS);
            }
        });
        this._updateBodyClass();
    };

    _updateBodyClass = () => {
        document.body.classList.remove(MENU_ACTIVE_CLASS);
        document.body.classList.remove(SUBMENU_ACTIVE_CLASS);

        this._menuItems.forEach((menuItem) => {
            if (menuItem.classList.contains(MENU_ACTIVE_CLASS)) {
                document.body.classList.add(MENU_ACTIVE_CLASS);
            }
            if (menuItem.classList.contains(SUBMENU_ACTIVE_CLASS)) {
                document.body.classList.add(SUBMENU_ACTIVE_CLASS);
            }
        });
    };
}

const mobileNav = new MobileNav();
